import React, { useState } from 'react';
import { sendPrompt } from './api/client';

function App() {
  const [prompt, setPrompt] = useState('');
  const [response, setResponse] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    try {
      const res = await sendPrompt(prompt);
      setResponse(res.message || JSON.stringify(res));
      setError('');
    } catch (err) {
      setError('Failed to send prompt.');
      setResponse('');
    }
  };

  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>
      <h2>Evo ASI Prompt Dashboard</h2>
      <textarea
        rows="4"
        cols="50"
        placeholder="Type your prompt here..."
        value={prompt}
        onChange={(e) => setPrompt(e.target.value)}
      />
      <br />
      <button onClick={handleSubmit} style={{ marginTop: '1rem' }}>
        Submit Prompt
      </button>

      <div style={{ marginTop: '2rem' }}>
        <h3>Response:</h3>
        <pre>{response}</pre>
        {error && <p style={{ color: 'red' }}>{error}</p>}
      </div>
    </div>
  );
}

export default App;

